import { render, staticRenderFns } from "./entrance.vue?vue&type=template&id=da84aa4c&scoped=true&"
import script from "./entrance.vue?vue&type=script&lang=js&"
export * from "./entrance.vue?vue&type=script&lang=js&"
import style0 from "./entrance.vue?vue&type=style&index=0&id=da84aa4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da84aa4c",
  null
  
)

export default component.exports